module.exports = __webpack_public_path__ + "img/pass.cd7c49d8.png";